import ElCheckboxGroup from './CheckboxGroup'

/* istanbul ignore next */
ElCheckboxGroup.install = function (app) {
  app.component(ElCheckboxGroup.name, ElCheckboxGroup)
}

export default ElCheckboxGroup
